
/* © 2017 - Copyright of Aetonix Systems Inc - All Rights Reserved. Patent pending.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Aetonix, January 01, 2017
 * For information or permission request, email info@aetonixsystems.com
 */

var Model = require("../types/Model.js");

/**
 * Keeps track of options for input preferences, availability.
 * Also tracks the state of the trunk.
 */
module.exports = Model({
	name: "callinputswitcher",
	init: init,
	triggers: triggers,
	listeners: listeners,

	open: open_ui,
	close: close_ui
});

function init() {
	this.push({
		input: {},
		open: false
	});
}

function triggers() {
	return {
		"open": open_ui,
		"close": close_ui,
		"choose": choose,
		"toggle": toggle_camera,
	};
}

function listeners() {
	return {
		"inputoptions:updated": handle_input_options_update
	};
}

function open_ui() {
	this.extend({
		open: true
	});
	this.emit("buzz:trigger:video:hide");
	this.emit("usermetrics:trigger:track", "open input options in old calling");
}

function close_ui() {
	this.extend({
		open: false
	});
	this.emit("buzz:trigger:video:show");
	this.emit("usermetrics:trigger:track", "close input options in old calling");
}

function choose(data) {
	this.emit("inputoptions:trigger:switch:video", data);
	this.close();
	this.emit("usermetrics:trigger:track", "choose input options in old calling");
}

function handle_input_options_update(input) {
	this.extend({
		input: input
	});
}

function toggle_camera() {
	this.emit("usermetrics:trigger:track", "toggle camera in old calling");
	var currentVideo = this.data.input.video;
	var videoSources = this.data.input.sources.video;
	if (!currentVideo)
		currentVideo = videoSources[0].value;
	var foundVideo = false;

	var videoCount = videoSources.length;
	for (var i = 0; i < videoCount; i++) {
		if (currentVideo === videoSources[i].value) {
			currentVideo = videoSources[(i + 1) % videoCount].value;
			foundVideo = true;
			break;
		}
	}

	// find index of current video
	// if an index could not be found, use first item
	if (!foundVideo) {
		currentVideo = videoSources[0].value;
	}

	this.emit("inputoptions:trigger:switch:video", {
		video: currentVideo
	});
}
